import gluedin from "gluedin-shorts-js";

const defaultLanguage = localStorage.getItem("defaultLanguage");

export const getLocalisedText = (obj, defaultKey) => {
  const localisedValue =
    obj?.[
      `localised${defaultKey.charAt(0).toUpperCase()}${defaultKey.slice(1)}`
    ]?.[defaultLanguage];
  return localisedValue || obj?.[defaultKey] || "";
};

export const isLoggedin = async () => {
  try {
    const accessToken = await new gluedin.GluedInAuthModule().getAccessToken();
    return !!accessToken;
  } catch (error) {
    console.error("Error fetching access token:", error);
    return false;
  }
};

export const formatLargeNumber = (count) => {
  if (count < 1000) {
    return count.toString();
  } else if (count < 1000000) {
    return `${(count / 1000).toFixed(1)}K`;
  } else {
    return `${(count / 1000000).toFixed(1)}M`;
  }
};

export const convertKToNumeric = (kValue) => {
  if (typeof kValue === "string" && kValue.match(/(\d+(\.\d+)?)(K|M|B)?/)) {
    const match = kValue.match(/(\d+(\.\d+)?)(K|M|B)?/);
    let numericValue = parseFloat(match[1]);
    const modifier = match[3];
    if (modifier) {
      if (modifier === "K") {
        numericValue *= 1000;
      } else if (modifier === "M") {
        numericValue *= 1000000;
      } else if (modifier === "B") {
        numericValue *= 1000000000;
      }
    }
    return numericValue;
  }
  return null;
};

export const formatUserStories = (data, offset) => {
  return data.map((user) => {
    if (user.stories.length > 0) {
      user = {
        userId: user.userId,
        totalStories: user.totalStories,
        fullName: user.stories[0].user.fullName,
        userName: user.stories[0].user.userName,
        profileImageUrl: user.stories[0].user.profileImageUrl,
        stories: user.stories,
        offset: offset,
      };
    }
    return user;
  });
};

// Helper function to handle both ISO string and timestamp formats (English only, plain strings)
export const getTimeAgo = (createdTimestamp, t) => {
  const now = Date.now(); // Current time in milliseconds

  // Convert ISO string to timestamp if necessary
  const createdTime =
    typeof createdTimestamp === "string"
      ? new Date(createdTimestamp).getTime()
      : createdTimestamp;

  const difference = now - createdTime;

  const seconds = Math.floor(difference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return `${t("label-just-now")}`;
  } else if (minutes === 1) {
    return `1m ${t("label-ago")}`;
  } else if (minutes < 60) {
    return `${minutes}m ${t("label-ago")}`;
  } else if (hours === 1) {
    return `1h ${t("label-ago")}`;
  } else if (hours < 24) {
    return `${hours}h ${t("label-ago")}`;
  } else if (days === 1) {
    return `1d ${t("label-ago")}`;
  } else {
    return `${days}d ${t("label-ago")}`;
  }
};

export const truncateWithEllipsis = (
  value,
  maxLength = 12,
  ellipsis = "..."
) => {
  if (value === null || value === undefined) return "";
  const text = String(value);
  const safeMaxLength = Number(maxLength);
  if (!Number.isFinite(safeMaxLength) || safeMaxLength <= 0) {
    return text;
  }
  if (text.length <= safeMaxLength) return text;
  return `${text.slice(0, safeMaxLength)}${ellipsis}`;
};

export const getCoinName = (appConfig, fallback = "Coins") => {
  const configuredName = appConfig?.appEconomy?.coinSettings?.coinName;
  if (typeof configuredName === "string" && configuredName.trim()) {
    return configuredName.trim();
  }
  if (typeof fallback === "string" && fallback.trim()) {
    return fallback.trim();
  }
  return "Coins";
};

export const replaceCoinWord = (value, coinName, fallback = "Coins") => {
  if (typeof value !== "string" || !value) return value;
  const resolvedCoinName = getCoinName(null, coinName || fallback);
  return value.replace(/\bcoins?\b/gi, resolvedCoinName);
};
